import { stopAudioElement } from './realtime/audio-element';

// Module-level, not a store: this measures the gap between "the backend says it
// dispatched a voice event" and "the user hears the first sample". Both ends are
// signalled from outside React (a socket message and an audio-analysis tick), so
// keeping it out of component state avoids re-render churn on every measurement.
let lastSignalReceivedAt = null;
let realtimeLatencyListener = null;

export function setRealtimeLatencyListener(listener) {
  realtimeLatencyListener = typeof listener === 'function' ? listener : null;
}

/**
 * Starts a measurement. Accepts an explicit timestamp (the backend can tell us
 * when it fired) and otherwise stamps now.
 */
export function markRealtimeLatencySignalReceived(signalReceivedAt) {
  lastSignalReceivedAt =
    typeof signalReceivedAt === 'number' && Number.isFinite(signalReceivedAt)
      ? signalReceivedAt
      : performance.now();
}

/**
 * Closes a measurement. Returns null when no measurement was open — playback can
 * start for reasons we never armed a timer for, and that isn't an error.
 */
export function markRealtimePlaybackStarted(source = 'audio.playing') {
  if (lastSignalReceivedAt === null) {
    return null;
  }

  const playbackStartedAt = performance.now();
  const latencyMs = playbackStartedAt - lastSignalReceivedAt;
  const payload = {
    latencyMs,
    latencySeconds: latencyMs / 1000,
    signalReceivedAt: lastSignalReceivedAt,
    playbackStartedAt,
    source,
  };

  lastSignalReceivedAt = null;
  realtimeLatencyListener?.(payload);

  return payload;
}

export function resetRealtimeLatencyMeasurement() {
  lastSignalReceivedAt = null;
}

export function stopCurrentRealtimePlayback(audioRef) {
  stopAudioElement(audioRef?.current ?? null);
  resetRealtimeLatencyMeasurement();
}
